import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { trackMetaEvent } from "../../utils/metaPixel";
import { GUIDED_TOUR_SIGNUP_URL } from "./constants";
import { GUIDED_TOUR_STEPS } from "./steps";

const GuidedTourContext = createContext(null);

export const GuidedTourProvider = ({ children }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const lastIndex = GUIDED_TOUR_STEPS.length - 1;

  const next = useCallback(() => {
    setStepIndex((current) =>
      current >= lastIndex ? current : current + 1
    );
  }, [lastIndex]);

  const prev = useCallback(() => {
    setStepIndex((current) => (current <= 0 ? current : current - 1));
  }, []);

  const goToSignup = useCallback(() => {
    trackMetaEvent("ViewContent", {
      content_name: "Conhecer Mais",
      content_category: "guided_tour",
    });
    window.location.assign(GUIDED_TOUR_SIGNUP_URL);
  }, []);

  const value = useMemo(
    () => ({
      stepIndex,
      step: GUIDED_TOUR_STEPS[stepIndex],
      steps: GUIDED_TOUR_STEPS,
      stepCount: GUIDED_TOUR_STEPS.length,
      isFirst: stepIndex === 0,
      isLast: stepIndex === lastIndex,
      next,
      prev,
      goToSignup,
    }),
    [stepIndex, lastIndex, next, prev, goToSignup]
  );

  return (
    <GuidedTourContext.Provider value={value}>
      {children}
    </GuidedTourContext.Provider>
  );
};

export const useGuidedTour = () => {
  const ctx = useContext(GuidedTourContext);
  if (!ctx) {
    throw new Error("useGuidedTour must be used within GuidedTourProvider");
  }
  return ctx;
};
